import upArrow from "../../assets/uparrowFilter.svg";
import downArrow from "../../assets/downarrowFilter.svg";
import React, { useEffect, useMemo, useState } from "react";
import { Button, CheckPicker } from "rsuite";
import { IPredectivePayload, IRoot } from "../../services/interface/IHome";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ALERT_TABS, PO_ALERT_DATA, STATUS_DATA } from "../../utils/dataconstants";
import { useGBPFilters } from "../../services/redux/hooks/useHome";
import { setApplyFilter, setApplyForecastFilter, setFilter, setSelectedGbpFilter } from "../../services/redux/reducer/filter.reducer";
import { useInventoryFilters } from "../../services/redux/hooks/useInventory";
import CustomLoader from "../../common/CustomLoader/CustomLoader";
import reload from "../../assets/reload.svg";
import moment from "moment";
import { ItemDataType } from "rsuite/esm/MultiCascadeTree";

const Filter = React.memo(({filterShowHandler,isVisible}:any) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const alertType = new URLSearchParams(location.search).get("alert") || "";
    const [loading, setLoading] = useState<boolean>(false);
    const [route, setRoute] = useState<string>(location?.pathname?.split("/")[location?.pathname?.split("/").length - 1]);
    // Filters selected
    const initialState:IPredectivePayload = {
        plant: [],
        l2: [],
        l3: [],
        materialDescription: [],
        material: [],
        mrpType: [],
        futureSegmentation: [],
        vendorName: [],
        clustername: [],
        alerts: [],
        reviewedFlag: [],
        poAlert: [],
        adjustedLogic:[],
    }
    const [selectedFilterData, setSelectedFilterData] = useState<IPredectivePayload>(initialState);
    const filterData = useSelector((state:IRoot)=>state.filter.gbpfilter);
    const plant = useSelector((state:IRoot)=>state.filter.selectedGBPFilter.plant);
    const material = useSelector((state:IRoot)=>state.filter.selectedGBPFilter.material);
    const lastUpdated = useSelector((state:IRoot)=>state.filter.lastUpdateDate);
    const {mutate:mutateFilters,data:resData} = useGBPFilters();
    const {mutate:mutateInvFilters, data:invData} = useInventoryFilters();

    const invFilterHandler = () => {
        mutateInvFilters(selectedFilterData);
    }

    const forecastFilterHandler=()=>{
        mutateFilters(selectedFilterData);
    }

    const removeHandler=()=>{
        setSelectedFilterData(initialState);
        dispatch(setSelectedGbpFilter(initialState));
        dispatch(setApplyFilter({"status" : false, "rowNo" : -1}));
    }

    const applyHandler=()=>{
        dispatch(setSelectedGbpFilter(selectedFilterData));
        dispatch(setApplyFilter({"status" : true, "rowNo" : -1}));
    }

    const removeForecastHandler=()=>{
        setSelectedFilterData(initialState);
        dispatch(setSelectedGbpFilter(initialState));
        dispatch(setApplyForecastFilter({"status" : false, "rowNo" : -1}));
    }

    const applyForecastHandler=()=>{
        dispatch(setSelectedGbpFilter(selectedFilterData));
        dispatch(setApplyForecastFilter({"status" : true, "rowNo" : -1}));
    }

    useEffect(()=>{
        setSelectedFilterData({
            ...selectedFilterData,
            alerts:[alertType],
            plant,
            material
        });
        dispatch(setSelectedGbpFilter({
            ...selectedFilterData,
            plant,
            material,
            alerts:[alertType]
        }));
    },[alertType, plant, material]);

    useEffect(()=>{
        if(route.includes("forecast-alerts"))
        mutateFilters(selectedFilterData);
        else if(route.includes("inventory-alert"))
        mutateInvFilters(selectedFilterData);
    },[]);

    useEffect(()=>{
        if(route.includes("forecast-alerts")){
            setLoading(true);
            if(resData){
                dispatch(setFilter(resData?.data));
                setLoading(false);
            }        
        }
    },[resData]);

    useEffect(()=>{
        if(route.includes("inventory-alert")){
            setLoading(true);
            if(invData){
                dispatch(setFilter(invData?.data));
                setLoading(false);
            }
        }
    },[invData]);
    
    const alertTypeDescription = useMemo(() => {
        const mappings:any = {
            HighOverForecasting: "Forecasting Alerts > High Over Forecasting",
            HighUnderForecasting: "Forecasting Alerts > High Under Forecasting",
            LowForecastAccuracy: "Forecasting Alerts > Low Forecast Accuracy",
            HighOutlierCorrection: "Forecasting Alerts > High Outlier Correction",
            VolatileForecast: "Forecasting Alerts > Volatile Forecast",
            PotentialOverstock: "Inventory Alerts > Potential Overstock Due to Open/Recently Closed POs",
            PotentialStockout: "Inventory Alerts > Potential Stockout",
            AgeingInventory: "Inventory Alerts > Ageing Inventory",
            DevaluedInventory: "Inventory Alerts > Devalued Inventory",
        };
        removeHandler();
        removeForecastHandler();
        return mappings?.[alertType] || '';
    }, [alertType]);

    return <>
        <div className={`flex flex-col gap-1 px-[2%] border-b-[1px] shadow ${!isVisible ? "pt-[8px] pb-[4px]" : "pt-[8px] pb-[12px]"}`}>
            <div className="flex items-center justify-between mb-1">
                <h3 className="page-title font-semibold">{alertTypeDescription}</h3>
                {<div className="flex gap-2">
                    <img src={reload} alt="reload" className="w-[1vw]" />
                    <p className="text-fs16 text-[#858585] font-semibold">Last Updated : <span>{moment(lastUpdated?.slice(0, 10)).format("M/DD/YYYY")}</span></p>
                </div>}
            </div>
        {/* Forecast Alert Filters */}
        {isVisible && route.includes("forecast-alerts") && 
        <div className="grid grid-cols-[1fr_auto] items-end">
            <div className="grid grid-cols-10 items-end gap-2">
                <div className="w-full">
                    <p className="filter-header font-semibold">District</p>
                    <CheckPicker
                        size="xs"
                        virtualized
                        block
                        placeholder="All"
                        loading={loading}
                        disabled={loading}
                        data={loading ? [] : filterData?.clustername}
                        labelKey="plantcode"
                        valueKey="cluster"
                        onChange={(data: any) => {                        
                            setSelectedFilterData({
                                ...selectedFilterData,
                                clustername: data
                            })
                        }}
                        onOpen={()=>forecastFilterHandler()}
                        value={selectedFilterData?.clustername}
                    />
                </div>
                <div className="w-full">
                    <p className="filter-header font-semibold">DC</p>
                    <CheckPicker
                        size="xs"
                        virtualized
                        block
                        placeholder="All"
                        loading={loading}
                        disabled={loading}
                        data={loading ? [] : filterData?.plant}
                        labelKey="plant"
                        valueKey="plant"
                        onChange={(data: any) => {
                            setSelectedFilterData({
                                ...selectedFilterData,
                                plant: data
                            })
                        }}
                        onOpen={()=>forecastFilterHandler()}
                        value={selectedFilterData.plant}
                    />
                </div>
                <div className="w-full">
                    <p className="filter-header font-semibold">Category (L2)</p>
                    <CheckPicker
                        size="xs"
                        virtualized
                        block
                        placeholder="All"
                        loading={loading}
                        disabled={loading}
                        data={loading ? [] : filterData?.l2}
                        labelKey="L2"
                        valueKey="L2"
                        onChange={(data: any) => {
                            setSelectedFilterData({
                                ...selectedFilterData,
                                l2: data
                            })
                        }}
                        onOpen={()=>forecastFilterHandler()}
                        value={selectedFilterData?.l2}
                    />
                </div>
                <div className="w-full">
                    <p className="filter-header font-semibold">Sub Category (L3)</p>
                    <CheckPicker
                        size="xs"
                        virtualized
                        block
                        placeholder="All"
                        loading={loading}
                        disabled={loading}
                        data={loading ? [] : filterData?.l3}
                        labelKey="L3"
                        valueKey="L3"
                        onChange={(data: any) => {
                            setSelectedFilterData({
                                ...selectedFilterData,
                                l3: data
                            })
                        }}
                        onOpen={()=>forecastFilterHandler()}
                        value={selectedFilterData?.l3}
                    />
                </div>
                <div className="w-full">
                    <p className="filter-header font-semibold">Item Id</p>
                    <CheckPicker
                        size="xs"
                        virtualized
                        block
                        placeholder="All"
                        loading={loading}
                        disabled={loading}
                        data={loading ? [] : filterData?.material}
                        menuClassName="custom-dropdown-menu"
                        labelKey="material"
                        valueKey="material"
                        onChange={(data: any) => {                        
                            setSelectedFilterData({
                                ...selectedFilterData,
                                material: data
                            })
                        }}
                        onOpen={()=>forecastFilterHandler()}
                        value={selectedFilterData?.material}
                    // value={selectedFilterData?.material}            
                    />
                </div>
                <div className="w-full">
                    <p className="filter-header font-semibold">Segmentation</p>
                    <CheckPicker
                        preventOverflow={true}
                        appearance="default"
                        size="xs"
                        menuClassName="dependent-filter"
                        virtualized
                        block
                        placeholder="All"
                        loading={loading}
                        disabled={loading}
                        data={loading ? [] : filterData?.futureSegmentation}
                        labelKey="futureSeg"
                        valueKey="futureSeg"
                        onChange={(data: any) => {
                            setSelectedFilterData({
                                ...selectedFilterData,
                                futureSegmentation: data
                            })
                        }}
                        className="dependent-filter"
                        onOpen={()=>forecastFilterHandler()}
                        value={selectedFilterData?.futureSegmentation}
                    />
                </div>
                <div className="w-full">
                    <p className="filter-header font-semibold">Vendor</p>
                    <CheckPicker
                        size="xs"
                        virtualized
                        block
                        placeholder="All"
                        loading={loading}
                        disabled={loading}
                        data={loading ? [] : filterData?.vendorName}
                        labelKey="vendor"
                        valueKey="vendor"
                        onChange={(data: any) => {
                            setSelectedFilterData({
                                ...selectedFilterData,
                                vendorName: data
                            })
                        }}
                        onOpen={()=>forecastFilterHandler()}
                        value={selectedFilterData?.vendorName}
                    />
                </div>
                <div className="w-full">
                    <p className="filter-header font-semibold">Alert's Status</p>
                    <CheckPicker
                        size="xs"
                        virtualized
                        block
                        placeholder="All"
                        loading={loading}
                        disabled={loading}
                        data={loading ? [] : STATUS_DATA}
                        onChange={(data: any) => {
                            setSelectedFilterData({
                                ...selectedFilterData,
                                reviewedFlag: data !== null ? data : []
                            });
                        }}
                        onOpen={()=>forecastFilterHandler()}
                        value={selectedFilterData?.reviewedFlag}
                    />
                </div>
            </div>    
            <div className="align-right flex gap-1">
                <Button onClick={removeForecastHandler} className="bg-[#949494] text-white px-[20px] h-[4vh] rounded font-semibold btn-text">
                    Clear
                </Button>
                <Button onClick={applyForecastHandler} className="bg-deloitteGreen text-white px-[20px] h-[4vh] rounded font-semibold btn-text">
                    Apply
                </Button>
            </div>
        </div>}

        {/* Inventory Alert Filters */}
        {isVisible && route.includes("inventory-alerts") && 
            <div className="grid grid-cols-[1fr_auto] items-end">
                <div className="grid grid-cols-10 items-end gap-2">
                    <div className="w-full">
                        <p className="filter-header font-semibold">District</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            loading={loading}
                            disabled={loading}
                            data={loading ? [] : filterData?.clustername}
                            labelKey="plantcode"
                            valueKey="plantcode"
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    clustername: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.clustername}
                        />
                    </div>
                    <div className="w-full">
                        <p className="filter-header font-semibold">DC</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            data={loading ? [] : filterData?.plant}
                            labelKey="plant"
                            valueKey="plant"
                            loading={loading}
                            disabled={loading}
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    plant: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.plant}
                        />
                    </div>
                    <div className="w-full">
                        <p className="filter-header font-semibold">Category (L2)</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            loading={loading}
                            disabled={loading}
                            data={loading ? [] : filterData?.l2}
                            labelKey="L2"
                            valueKey="L2"
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    l2: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.l2}
                        />
                    </div>
                    <div className="w-full">
                        <p className="filter-header font-semibold">Item Id</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            loading={loading}
                            disabled={loading}
                            data={loading ? [] : filterData?.material}
                            labelKey="material"
                            valueKey="material"
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    material: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.material}
                        />
                    </div>
                    <div className="w-full">
                        <p className="filter-header font-semibold">Segmentation</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            loading={loading}
                            menuClassName="dependent-filter"
                            disabled={loading}
                            data={loading ? [] : filterData?.futureSegmentation}
                            labelKey="futureSeg"
                            valueKey="futureSeg"
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    futureSegmentation: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.futureSegmentation}
                            className="dependent-filter"
                        />
                    </div>
                    {alertType === "PotentialOverstock" && <div className="w-full">
                        <p className="filter-header font-semibold">PO Type</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            loading={loading}
                            disabled={loading}
                            data={loading ? [] : PO_ALERT_DATA}
                            labelKey="label"
                            valueKey="value"
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    poAlert: data !== null ? data : []
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.poAlert}
                        />
                    </div>}
                    {["PotentialStockout", "AgeingInventory", "PotentialOverstock", "DevaluedInventory"].includes(String(alertType)) && <div className="w-full">
                        <p className="filter-header font-semibold">Vendor</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            loading={loading}
                            disabled={loading}
                            data={loading ? [] : filterData?.vendorName}
                            labelKey="vendor"
                            valueKey="vendor"
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    vendorName: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.vendorName}
                        />
                    </div>}
                    <div className="w-full">
                        <p className="filter-header font-semibold">Potential Actions</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            loading={loading}
                            menuClassName="dependent-filter"
                            disabled={loading}
                            data={loading ? [] : filterData?.recommendedAction as ItemDataType<never>[]}
                            labelKey="RecommendedAction"
                            valueKey="RecommendedAction"
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    recommendedAction: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.recommendedAction}
                            className="dependent-filter"
                        />
                    </div>
                    <div className="w-full">
                        <p className="filter-header font-semibold">Inventory Age</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            loading={loading}
                            menuClassName="dependent-filter"
                            disabled={loading}
                            data={loading ? [] : filterData?.InventoryAgeBuckets as ItemDataType<never>[]}
                            labelKey="InventoryAgeBuckets"
                            valueKey="InventoryAgeBuckets"
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    InventoryAgeBuckets: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.InventoryAgeBuckets}
                            className="dependent-filter"
                        />
                    </div>
                </div>
                <div className="align-right flex gap-1">
                    <Button onClick={removeHandler} className="bg-[#949494] text-white px-[20px] h-[4vh] rounded font-semibold btn-text">
                        Clear
                    </Button>
                    <Button onClick={applyHandler} className="bg-deloitteGreen text-white px-[20px] h-[4vh] rounded font-semibold btn-text">
                        Apply
                    </Button>
                </div>
        </div>}

        {/* Performance Metrics Filters */}
         {isVisible && route.includes("PerformanceMetrics") && 
            <div className="grid grid-cols-[1fr_auto] items-end">
                <div className="grid grid-cols-10 items-end gap-2">
                    <div className="w-full">
                        <p className="filter-header font-semibold">PC</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            loading={loading}
                            disabled={loading}
                            data={loading ? [] : filterData?.clustername}
                            labelKey="plantcode"
                            valueKey="plantcode"
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    clustername: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.clustername}
                        />
                    </div>
                    <div className="w-full">
                        <p className="filter-header font-semibold">Price Line</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            data={loading ? [] : filterData?.plant}
                            labelKey="plant"
                            valueKey="plant"
                            loading={loading}
                            disabled={loading}
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    plant: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.plant}
                        />
                    </div>
                    <div className="w-full">
                        <p className="filter-header font-semibold">SKU</p>
                        <CheckPicker
                            size="xs"
                            virtualized
                            block
                            placeholder="All"
                            loading={loading}
                            disabled={loading}
                            data={loading ? [] : filterData?.l2}
                            labelKey="L2"
                            valueKey="L2"
                            onChange={(data: any) => {
                                setSelectedFilterData({
                                    ...selectedFilterData,
                                    l2: data
                                })
                            }}
                            onOpen={() => invFilterHandler()}
                            value={selectedFilterData?.l2}
                        />
                    </div>
                </div>
                <div className="align-right flex gap-1">
                    <Button onClick={removeHandler} className="bg-[#949494] text-white px-[20px] h-[4vh] rounded font-semibold btn-text">
                        Clear
                    </Button>
                    <Button onClick={applyHandler} className="bg-deloitteGreen text-white px-[20px] h-[4vh] rounded font-semibold btn-text">
                        Apply
                    </Button>
                </div>
        </div>}

        <div className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer" onClick={filterShowHandler}>
            {isVisible && <img className="w-[1.5vw]" src={upArrow} alt="upArrow" />}
            {!isVisible && <img className="w-[1.5vw]" src={downArrow} alt="downArrow" />}
        </div>
    </div>
    {loading && <CustomLoader open={loading} />}
    </>
})

export default Filter;